import { ContentNode } from '../models/content-node.model';

export class AddContentNodes {
    static readonly type = '[ContentNode] AddContentNodes';

    constructor(public payload: ContentNode[]) {}
}
